/**
 * Store initialization file
 *
 * This file initializes all store subscriptions and cross-store dependencies
 * to avoid circular dependency issues.
 */

import { setupPairSubscriptions } from "./pair.store";

/**
 * Initialize all store subscriptions
 * Call this function after all stores are loaded
 */
export const initializeStores = () => {
    // Set up pair store subscriptions
    setupPairSubscriptions();

    // Add other store initializations here as needed
};
